import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons";

const Books = ({ renderBody }) => {
  const { t } = useTranslation();

  return (
    <div className="container subpage-container mt-5 pt-4 border-top">
      <div className="text-center mb-4">
        <h2 className="subpage-title">{t("magazines.books")}</h2>
      </div>

      <div className="card book-feature-card border-0 shadow-sm rounded-4 p-4 p-md-5 bg-white">
        <div className="row align-items-center g-4 mb-4">
          <div className="col-md-4 text-center">
            <img
              src="https://res.cloudinary.com/orchestrabusoni/image/upload/v1647612079/clip_image002_u4fmbl.jpg"
              alt="Oggi come mezzo secolo fa"
              className="img-fluid rounded-3 shadow book-cover-img"
              style={{ maxHeight: "280px" }}
              loading="lazy"
            />
          </div>
          <div className="col-md-8">
            <span className="badge bg-warning text-dark px-3 py-1 rounded-pill fw-semibold mb-2">
              1965 – 2015 • 50° Anniversario
            </span>
            <h3 className="subpage-title mb-2">Oggi come mezzo secolo fa</h3>
            <p className="text-muted fw-semibold mb-0">
              {t("magazines.books_intro")}
            </p>
          </div>
        </div>

        <div className="book-essay-box p-4 rounded-4 bg-light border">
          <div className="mb-2 text-warning fs-4">
            <FontAwesomeIcon icon={faQuoteLeft} />
          </div>
          <div className="subpage-text-content">
            {renderBody(t("magazines.books_body"))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Books;
